//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Renders model card on dashboard
 * and also model on Model view.
 */
import Chart from "chart.js";
import annotation from "chartjs-plugin-annotation";
import {BProgress, BProgressBar} from "bootstrap-vue";
import "@nuxeo/nuxeo-elements/nuxeo-operation.js";
import "@nuxeo/nuxeo-ui-elements/actions/nuxeo-notifications-toggle-button";
import {insightService} from "@/insight-service";
import {mapGetters, mapMutations} from "vuex";
import RadialProgressBar from "vue-radial-progress";
import {modelStates} from "@/constants";

export default {
  name: "PublishedModelCard",
  components: {
    RadialProgressBar,
    BProgress,
    BProgressBar,
  },
  props: {
    /**
     * Renders the model info on the dashboard.
     */
    model: {
      type: Object,
      value: {},
    },
    /**
     * False if the model appears as a card in dashboard,
     * true if it appears as the model page.
     */
    summary: {
      type: Boolean,
      value: false,
    },

    exportPollEnabled: {
      type: Boolean,
      value: false,
    },
  },

  data() {
    return {
      closeOnClick: true,
      //lists versions in current model
      versions: {},
      completedSteps: 0,
      progressSteps: 0,
      progress: 0,
      progressPending: 0,
      elapsedTime: "",
      // VueJS requires to assign data and not props (see toggleVersion method)
      dataModel: this.model,
      graphKeyRender: 0,
      currentGraph: {},
      exportStatus: {},
      exportTimeOut: null,
      diameter: 230,
    };
  },

  watch: {
    dataModel: function () {
      this.loadModelMetrics();
      this.exportPoll();
    },
  },

  mounted() {
    this.loadModelMetrics();
    this.initVersions();
    this.exportPoll();
  },

  beforeDestroy() {
    clearTimeout(this.exportTimeOut);
  },

  computed: {
    ...mapGetters(["modelsPP", "enrichers", "currentClient"]),
    progressLabel() {
      return `${this.progress}%`;
    },
    inputs() {
      const inputs = this.dataModel.properties["ai_model:inputs"];
      return inputs.map((e) => e.name);
    },
    outputs() {
      const outputs = this.dataModel.properties["ai_model:outputs"];
      return outputs.map((e) => e.name);
    },

    isFavorites() {
      return insightService.isFavorites(this.dataModel);
    },

    isNotif() {
      return insightService.isNotif(this.dataModel);
    },

    isModelFailed() {
      return (
          this.dataModel.state === modelStates.FIRST_TRAINING_ERROR ||
          this.dataModel.state === modelStates.EVALUATION_ERROR ||
          this.dataModel.state === modelStates.NOT_TRAINED
      );
    },
  },

  methods: {
    navigateToDashboard() {
      this.$router.push({name: "dashboard"});
    },

    execute(action) {
      return this.$refs[`${action}`].execute();
    },

    deleteAction() {
      this.execute("delete")
          .then(() => {
            this.displaySuccess(
                this.$t("card.active.model.action.delete.success")
            );
            window.setTimeout(() => {
              this.navigateToDashboard();
            }, 500);
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    publishAction() {
      this.execute("publish")
          .then((returnedModel) => {
            this.dataModel = returnedModel;
            this.displaySuccess(
                this.$t("card.active.model.action.publish.success")
            );
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    unpublishAction() {
      this.execute("unpublish")
          .then(() => {
            this.displaySuccess(
                this.$t("card.active.model.action.unpublish.success")
            );
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    trainAction() {
      this.displaySuccess(this.$t("card.active.model.action.train.start"));
      this.execute("train")
          .then((returnedModel) => {
            this.dataModel = returnedModel;
            this.displaySuccess(
                this.$t("card.active.model.action.train.success")
            );
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    abortAction() {
      this.displaySuccess(this.$t("actions.abort.success"));
      this.execute("abort")
          .then((returnedModel) => {
            this.dataModel = returnedModel;
            this.displaySuccess(this.$t("actions.abort.success"));
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    optimizeAction() {
      this.displaySuccess(this.$t("card.active.model.action.optimize.start"));
      this.execute("optimize")
          .then((returnedModel) => {
            this.dataModel = returnedModel;
            this.displaySuccess(
                this.$t("card.active.model.action.optimize.success")
            );
          })
          .catch((error) => {
            this.displayError(error);
          });
    },

    navigateToModel() {
      this.setCurrentModel(this.dataModel);
      this.$router.push({name: "model", params: {id: this.dataModel.uid}});
    },

    selectClick(e) {
      this.$toasted.show(`Select btn clicked ${e}`, {duration: 2000});
    },

    isTraining(model) {
      return insightService.isTraining(model);
    },

    isPublished(model) {
      return insightService.isPublished(model);
    },

    isTrained(model) {
      return insightService.isTrained(model);
    },

    loadModelMetrics() {
      window.setTimeout(() => {
        if (this.summary) {
          this.completedSteps = parseFloat(
              (this.dataModel.properties["ai_model:main_result"] * 100).toFixed(2)
          );
        }
        if (insightService.isTraining(this.dataModel)) {
          const results = insightService.fillTrainingMetrics(this.dataModel);
          this.progress = results.progress;
          this.progressPending = (results.progressPending * 100).toFixed(2);
          this.progressSteps = (results.progressSteps * 100).toFixed(2);
          this.elapsedTime = results.elapsedTime;
          if (insightService.isRunning(this.dataModel)) {
            this.startElapsedTrainingTimeCounter();
          }
        }
        if (
            this.isTrained(this.dataModel) ||
            this.isPublished(this.dataModel)
        ) {
          this.createChart(
              this.dataModel.properties["ai_model:deployment_information"]
                  .publishing_state,
              this.dataModel.state
          );
        }
      }, 100);
    },

    startElapsedTrainingTimeCounter() {
      const jobInfo = this.dataModel.contextParameters.jobInfo;
      if (jobInfo) {
        window.setTimeout(() => {
          const time = insightService.getElapsedTime(jobInfo.startDate);
          this.elapsedTime = `${time}`;
          this.startElapsedTrainingTimeCounter();
        }, 1000);
      }
    },

    exportPoll() {
      if (this.exportPollEnabled) {
        this.$refs.aiExportProgress.params = {
          modelId: this.dataModel.uid,
        };
        this.$refs.aiExportProgress.execute().then((resp) => {
          // if there is no export in progress the operation will return null
          if (resp.status === 204) {
            clearTimeout(this.exportTimeOut);
            return;
          }
          this.exportStatus = resp.value;
          console.log("Received export statuses", this.exportStatus);
          this.exportTimeOut = setTimeout(() => {
            this.exportPoll();
          }, 2000);
        })
      }
    },

    initVersions() {
      if (this.dataModel && Object.keys(this.dataModel).length !== 0) {
        this.versions = this.dataModel.contextParameters.versions.entries.reduce(
            (obj, version) => {
              obj[version.uid] = version;
              return obj;
            },
            {}
        );
      }
    },

    createChart(state = "published", lifeCycleState) {
      if (Object.keys(this.currentGraph).length !== 0) {
        this.currentGraph.destroy();
      }
      const ctx = this.$refs.cardChart.getContext("2d");
      let gradientStroke = ctx.createLinearGradient(500, 0, 0, 400);
      let primaryColor = "#53A0FD";
      let secondaryColor = "#D60000";
      switch (state) {
        case "never_published":
          primaryColor = "#a1a1a1";
          secondaryColor = "#ffffff";
          break;
        case "publishing_pending":
          primaryColor = "#473ef7";
          secondaryColor = "#ffffff";
          break;
        case "publishing_failed":
          primaryColor = "#f50202";
          secondaryColor = "#ffffff";
          break;
        case "published":
          break;
        default:
          if (lifeCycleState === modelStates.TRAINED) {
            primaryColor = "#a1a1a1";
            secondaryColor = "#ffffff";
          }
          break;
      }

      gradientStroke.addColorStop(0.2, primaryColor);
      gradientStroke.addColorStop(1, secondaryColor);

      /* Plot evaluations results */

      const evaluations = this.dataModel.contextParameters.evaluations;
      const trainingAccuracy = this.dataModel.properties[
          "ai_model:main_result"
          ];
      const evalResults = evaluations.eval_results;

      let data = [];
      let dataLine = [];
      let dates = [];
      let disableChart = true;

      // xAxes - the training date
      dates.push(
          insightService.formatDate(
              this.dataModel.properties["job_sagemaker:end"]
          )
      );
      // yAxes - all evaluations results
      dataLine.push((trainingAccuracy * 100).toFixed(2));
      data.push((trainingAccuracy * 100).toFixed(2));
      // x and y Axes - dates and values of evaluations
      if (evalResults && Object.keys(evalResults).length !== 0) {
        disableChart = false;
        evalResults.forEach((result) => {
          dates.push(insightService.formatDate(result.time));
          data.push((result.accuracy * 100).toFixed(2));
          dataLine.push((trainingAccuracy * 100).toFixed(2));
        });
      }

      if (disableChart && trainingAccuracy && trainingAccuracy !== 0) {
        dates.push(insightService.today());
        dataLine.push(trainingAccuracy * 100);
      }

      let annotations = {};
      if (disableChart) {
        annotations = {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 50,
              borderColor: "black",
              borderWidth: 0.1,
              label: {
                content: "No evaluations yet",
                enabled: true,
              },
            },
          ],
        };
      }

      this.currentGraph = new Chart(this.$refs.cardChart, {
        plugins: [annotation],
        maintainAspectRatio: true,
        type: "line",
        data: {
          datasets: [
            {
              label: this.$t("graph.axis.training"),
              data: dataLine,
              borderColor: "grey",
              borderWidth: 1,
              borderDash: [5, 5],
              fill: false,
              pointRadius: 0,
            },
            {
              label: this.$t("graph.axis.evaluations"),
              data: data,
              borderColor: gradientStroke,
              backgroundColor: gradientStroke,
              borderWidth: 1,
              fill: true,
              pointRadius: 0,
            },
          ],
        },
        options: {
          annotation: annotations,
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: "index",
          },
          legend: {
            display: this.summary,
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                display: this.summary,
                type: "category",
                labels: dates,
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
              },
            ],
            yAxes: [
              {
                display: this.summary,
                scaleLabel: {
                  display: false,
                  // labelString: 'Accuracy',
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
                ticks: {
                  beginAtZero: true,
                  stepSize: 25,
                  max: 100,
                  callback: function (value) {
                    return value + "%";
                  },
                },
              },
            ],
          },
        },
      });
    },

    toggleFav() {
      insightService.toggleFavorite(
          this.dataModel,
          this.$refs.addFav,
          this.$refs.removeFav,
          this.displaySuccess,
          this.displayError,
          this.setModels,
          this.modelsPP,
          this.summary,
          this.displayLoading
      );
      if (this.summary) {
        this.dataModel.contextParameters.favorites.isFavorite = !this.dataModel
            .contextParameters.favorites.isFavorite;
      }
    },
    toggleNotif() {
      insightService.toggleNotif(
          this.dataModel,
          this.$refs.subscribe,
          this.$refs.unsubscribe,
          this.displaySuccess,
          this.displayError,
          this.setModels,
          this.modelsPP,
          this.summary,
          this.displayLoading
      );
      if (this.summary) {
        const notifs = this.dataModel.contextParameters.subscribedNotifications;
        this.dataModel.contextParameters.subscribedNotifications =
            notifs.length > 0 ? [] : ["done"];
      }
    },
    toggleVersion(e) {
      const uidProp = e.target.attributes.uid;
      if (uidProp) {
        this.versions[this.dataModel.uid] = this.dataModel;
        this.dataModel = this.versions[uidProp.value];
        delete this.versions[uidProp.value];
        this.setCurrentModel(this.dataModel);
        this.$router.replace({name: "model", params: {id: this.dataModel.uid}});
      }
    },
    ...mapMutations({
      displaySuccess: "displaySuccess",
      displayError: "displayError",
      setModels: "setModels",
      setCurrentModel: "setCurrentModel",
      displayLoading: "displayLoading",
    }),
  },
};
